import { Spinner, SpinnerSize } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { TransferEstimationDates, TransferSimulationManagerInfo } from "../../../services/FundService";
import { SectionContainer, WarningContainer } from "./styles";
import TransferManagerRiskCard from "./TransferManagerRiskCard";
import { WarningIcon } from "@fluentui/react-icons-mdl2";

type TransferProps = {
	transferEstimationDates: TransferEstimationDates;
	simulationManagerInfoOrigin?: TransferSimulationManagerInfo[];
	simulationManagerInfoTarget?: TransferSimulationManagerInfo[];
	isLoadingProps?: boolean;
	orderDate?: string;
};
type TKeyVal = {
	key: string;
	value: string;
	style: string;
	text: string;
	date: Date;
	styleText?: string;
}

function calculateDaysOutOfMarket(date1: string, date2: string) {
	let date1Array = date1.split("/");
	let date2Array = date2.split("/");

	let date1Converted = new Date(date1Array[2] + "-" + date1Array[1] + "-" + date1Array[0]);
	let date2Converted = new Date(date2Array[2] + "-" + date2Array[1] + "-" + date2Array[0]);

	return Math.abs(+date2Converted - +date1Converted) / 86400000;
}

export const TransferTimeLineProgress = (props: TransferProps) => {
	const { simulationManagerInfoOrigin, simulationManagerInfoTarget, isLoadingProps } = props;
	const theme = window.localStorage.getItem("theme") || "light";
	const [cronologyData, setCronologyData] = useState<TKeyVal[]>()

	const isValidData: boolean =
		props.transferEstimationDates.compraLiquidacion !== "" &&
		props.transferEstimationDates.compraValor !== "" &&
		props.transferEstimationDates.ventaLiquidacion !== "" &&
		props.transferEstimationDates.ventaValor !== "" &&
		props.transferEstimationDates.finalProceso !== "";

	const days = calculateDaysOutOfMarket(props.transferEstimationDates.compraValor, props.transferEstimationDates.ventaValor);

	const parseDDMMYYYY = (s: string) => {
		const [d, m, y] = s.split('/');
		return new Date(Number(y), Number(m) - 1, Number(d));
	};

	const insertTodayChronologically = (arr: TKeyVal[]) => {
		const todayDate = new Date();
		const todayData = {key: "Hoy", value: todayDate.toLocaleDateString(), style: "rombo", text: "", date: todayDate}
		const result = [...arr];
		const todayIndex = result.findIndex(item => parseDDMMYYYY(item.value).getTime() === todayDate.getTime());
		const index = result.findIndex(item => parseDDMMYYYY(item.value) > todayDate);
		if (todayIndex !== -1) {
			result[todayIndex].style = "rombo";
			result[todayIndex].styleText = "circleTextRomboBlack";
		} else {
			if (index === -1) {
				result.push(todayData);
			} else {
				result.splice(index, 0, todayData);
			}
		}

		return result.sort((a, b) => a.date.getTime() - b.date.getTime());
	};

	const manageText = (key: string) => {
		let text: string = "";
		switch (key) {
			case "ventaValor":
				text = "Fecha de Valor Liquidativo Salida";
				break;
			case "ventaLiquidacion":
				text = "Fecha Liquidación Salida"
				break;
			case "compraValor":
				text = "Fecha Valor Liquidativo Entrada"
				break;
			case "compraLiquidacion":
				text = "Fecha Liquidación Entrada"
				break;
			default:
				return "";
		}
		return text;
	};

	const manageCurrentDay = () => {
		const keyValueData = Object.entries(props.transferEstimationDates).map(([key, value]) => ({
			key,
			value,
			style: key.includes("venta") ? "circleVenta realized" : "circleCompra active",
			text: manageText(key),
			date: parseDDMMYYYY(value)
		}));
		
		setCronologyData(insertTodayChronologically(keyValueData));
	}

	useEffect(() => {
		manageCurrentDay();
	},[props.transferEstimationDates]);

	return (
		<React.Fragment>
			<React.Fragment>
				<div className={"ms-Grid-row principalRowContainer" + (theme === "dark" ? "Black" : "")}>
					<React.Fragment>
						{!isLoadingProps && isValidData && (
							<>
								<div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6 ms-xl6 ms-xxl6 ms-xxxl6">
									<p className={"textTitle" + (theme === "dark" ? "White" : "Black")}>Simulación de tiempo de Traspaso</p>
								</div>
								<div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6 ms-xl6 ms-xxl6 ms-xxxl6">
									<p className={"outMarketText" + (theme === "dark" ? "White" : "Black")}>Días fuera de Mercado: {days}</p>
								</div>
								<div className="transferManagerContainer">
									<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl2 ms-xxl2 ms-xxxl2" style={{ padding: "0px" }}>
										{simulationManagerInfoOrigin &&
											simulationManagerInfoOrigin.map((manager, index) => (
												<TransferManagerRiskCard
													key={index}
													index={index}
													isOrigin={true}
													theme={theme}
													name={manager.manager}
													koRatio={manager.ratioKOOrigen}
													okRatio={manager.ratioOKOrigen}
													totalTransfers={manager.totalOrigen}
												></TransferManagerRiskCard>
											))}
									</div>
									<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl8 ms-xxl8 ms-xxxl8">
										<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12">
											<div className="bodyContainer">
												<div className="container">
													<div className="progress-container">
														<div className="progress"></div>
														<div className="circleVenta realized"></div>
														{cronologyData?.map((item: TKeyVal) => (
															<div key={item.key} className="graphic__info">
																
															<div className={item.style}>
																
															</div>
															<p className={item.styleText ? item.styleText : "circleText" + (theme === "dark" ? "White" : "Black")}>
																	{item.text}
																</p>
															
															</div>
															)
														)}
													</div>
												</div>
											</div>
										</div>
										<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12">
											<div className="dateBody-container">
												<div className="container">
													<div className="date-container">
														<div className="circleEmptyLeft">{props.orderDate || new Date().toLocaleDateString()}</div>
														{cronologyData?.map((item: TKeyVal) => (
																<p key={item.key} className={"circleDate" + (theme === "dark" ? "White" : "Black")}>
																	{item.value}
																</p>
															)
														)}
													</div>
												</div>
											</div>
										</div>
	
									</div>
									<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl2 ms-xxl2 ms-xxxl2" style={{ padding: "0px" }}>
										{simulationManagerInfoTarget &&
											simulationManagerInfoTarget.map((manager, index) => (
												<TransferManagerRiskCard
													key={index}
													index={index}
													isOrigin={false}
													theme={theme}
													name={manager.manager}
													koRatio={manager.ratioKODestino}
													okRatio={manager.ratioOKDestino}
													totalTransfers={manager.totalDestino}
												></TransferManagerRiskCard>
											))}
									</div>
								</div>
								<div className="leyendaSimulacionModal__container">
									<div className="leyendaSimulacionModal__info">
										<span>Salida</span>
										<div className="circleVenta realized" />
									</div>
									<div className="leyendaSimulacionModal__info">
										<span>Entrada</span>
										<div className="circleCompra active" />
									</div>
									<div className="leyendaSimulacionModal__info">
										<span>Día actual</span>
										<div className="rombo rombo__leyenda" />
									</div>
								</div>
							</>
							
						)}
						{(isLoadingProps || !isValidData) && (
							<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12 loadingContainer">
								<Spinner size={SpinnerSize.large} className="button-spinner" />
							</div>
						)}
						<SectionContainer className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12">
							{!isLoadingProps && simulationManagerInfoTarget?.find(x => x.switchable === false) !== undefined && (
								<div className="noTraspasable">
									<p>
										<WarningIcon className="warningIcon" />
										Fondo destino no traspasable
									</p>
								</div>
							)}

							<WarningContainer className="warningContainer">
								<div>
									<img src="/icons/information.svg" alt="Información" />
								</div>
								<p>
									Las fechas de valor liquidativo y liquidación, así como los días fuera de mercado expuestos son una estimación informativa
									que NO tiene en cuenta los días no laborables del país de origen del fondo y no constituyen una garantía para ningún tipo de
									reclamación por dicha información expuesta. Asimismo, se recuerda al inversor que para poder calcular la estimación más
									exacta, deberá analizar la memoria de comercialización, el folleto y el resto de documentaciones pre-contractuales de los
									vehículos donde figuren las horas de corte y el periodo del cálculo liquidativo establecidas por las entidades
									comercializadoras y las gestoras de los mismos.
								</p>
							</WarningContainer>
						</SectionContainer>
					</React.Fragment>
				</div>
			</React.Fragment>
		</React.Fragment>
	);
};
